import { IAvatarSkin } from './avatarSkin';
import { IEvent } from './event';
import { IParticipant } from './participants';

export const ExperienceRoles = {
  Facilitator: 'FACILITATOR',
  ExperienceMember: 'EXPERIENCE_MEMBER',
} as const;

// eslint-disable-next-line @typescript-eslint/no-redeclare -- intentional const+type merge idiom, not a duplicate
export type ExperienceRoles =
  (typeof ExperienceRoles)[keyof typeof ExperienceRoles];

/** Mirrors the backend `DegradedService` enum (MV-1856). */
export const DegradedService = {
  StreamChat: 'STREAM_CHAT',
} as const;

// eslint-disable-next-line @typescript-eslint/no-redeclare -- intentional const+type merge idiom, not a duplicate
export type DegradedService =
  (typeof DegradedService)[keyof typeof DegradedService];

export type EventParticipantStateQuestType = {
  QuestId: string;
  bIsFinish: boolean;
};

export type EventParticipantStateType = {
  bIsOliver: boolean;
  bIsTicket: boolean;
  bIsFirstJoin: boolean;
  bIsCelebrationMoment: boolean;
  TutorialTag: string;
  QuestEntities: EventParticipantStateQuestType[];
};

export interface IEventParticipant {
  role?: string;
  skinId?: string;
  participantsSound?: number;
  selectedLanguage?: string;
  gameSound?: number;
  eventId?: string;
  participantId?: string;
  experienceMode?: string;
  event?: IEvent;
  participant?: IParticipant;

  skin?: IAvatarSkin;

  dolbyToken?: string | null;
  streamChatToken?: string | null;
  streamChatMemberId?: string | null;
  /** Services that were unavailable while the backend built this response. */
  unavailableServices?: DegradedService[] | null;

  isHubMultiplayer?: boolean | null;
  state?: string | null;
  assistantState?: string | null;

  isDisabled?: boolean;

  startDate?: number;
  endDate?: number;
  /** When this participant last joined the experience; 0 / absent if never. */
  lastJoinTime?: number;
  isDemo?: boolean;
  navigationMode?: string;
}
